/* eslint-disable */
import { BiShoppingBag, BiPencil } from "react-icons/bi";
import { BsCodeSlash, BsClipboardData } from "react-icons/bs";
import { AiOutlineMail, AiFillAudio } from "react-icons/ai";
import { FaInternetExplorer,  FaChalkboardTeacher, FaCameraRetro, FaPinterest, FaVideo, FaTabletAlt, FaRegNewspaper } from "react-icons/fa";

 

export const servicesData = [
 
    {
        id: 2,
        title: 'Blog Writing',
        icon: <BiPencil /> 
    },
 
    {
        id: 6,
        title: 'FrontEnd Engineering',
        icon: <BsCodeSlash />
    },
    {
        id: 6,
        title: 'Server-Side Engineering',
        icon: <BsCodeSlash />
    },

    {
        id: 13,
        title: 'Database Creation',
        icon: <FaRegNewspaper />
    },

]

